import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type MarkManyExpertNotificationsAsViewedMutationVariables = Types.Exact<{
  notificationIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;

export type MarkManyExpertNotificationsAsViewedMutation = {
  __typename?: 'Mutation';
  markManyExpertNotificationsAsViewed: Array<{
    __typename?: 'ExpertNotificationType';
    id: string;
    viewedAt?: any | null;
  }>;
};

export const MarkManyExpertNotificationsAsViewedDocument = gql`
  mutation markManyExpertNotificationsAsViewed($notificationIds: [String!]!) {
    markManyExpertNotificationsAsViewed(notificationIds: $notificationIds) {
      id
      viewedAt
    }
  }
`;
export type MarkManyExpertNotificationsAsViewedMutationFn = Apollo.MutationFunction<
  MarkManyExpertNotificationsAsViewedMutation,
  MarkManyExpertNotificationsAsViewedMutationVariables
>;

/**
 * __useMarkManyExpertNotificationsAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkManyExpertNotificationsAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkManyExpertNotificationsAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markManyExpertNotificationsAsViewedMutation, { data, loading, error }] = useMarkManyExpertNotificationsAsViewedMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkManyExpertNotificationsAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkManyExpertNotificationsAsViewedMutation,
    MarkManyExpertNotificationsAsViewedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkManyExpertNotificationsAsViewedMutation,
    MarkManyExpertNotificationsAsViewedMutationVariables
  >(MarkManyExpertNotificationsAsViewedDocument, options);
}
export type MarkManyExpertNotificationsAsViewedMutationHookResult = ReturnType<
  typeof useMarkManyExpertNotificationsAsViewedMutation
>;
export type MarkManyExpertNotificationsAsViewedMutationResult =
  Apollo.MutationResult<MarkManyExpertNotificationsAsViewedMutation>;
export type MarkManyExpertNotificationsAsViewedMutationOptions = Apollo.BaseMutationOptions<
  MarkManyExpertNotificationsAsViewedMutation,
  MarkManyExpertNotificationsAsViewedMutationVariables
>;
